// A preselected branch is not a completed availability search.
export const hasBookingSelection = (selection) => Boolean(
  selection?.branch && selection?.room
  && Number.isFinite(Number(selection.start_time)) && Number(selection.start_time) > 0
  && Number.isFinite(Number(selection.end_time)) && Number(selection.end_time) > Number(selection.start_time)
);
